<ion-menu
  contentId="main-content"
  menuId="filters"
  side="end"
  swipeGesture="false"
  class="filters-menu"
>
  <ion-content
    class="bg-gradient"
    scroll-y="true"
  >
    <div class="px-8 filter-container flex flex-col pb-2 pt-2">
      <div class="filters-header w-full flex justify-between items-center py-2">
        <ion-button
          color="light"
          mode="ios"
          fill="clear"
          (click)="clearFilters()"
          class="filters-button clear"
          size="small"
        >
          <ion-label class="text-[12px] underline">{{ 'FILTERS.CLEAR_ALL' | translate }}</ion-label>
        </ion-button>
        <ion-button
          color="light"
          mode="ios"
          fill="clear"
          (click)="toggleFilters()"
          class="filters-button"
        >
          <ion-icon
            class="text-[22px]"
            slot="icon-only"
            src="../../../assets/svg/filters.svg"
          ></ion-icon>
        </ion-button>
      </div>

      <div class="flex-1 overflow-y-auto filters-scroll-area">

        <!-- Mostrar mensaje de error para categorías si existe -->
        <div *ngIf="categoryError" class="text-danger text-[12px] px-4 mb-2">
          {{ categoryError }}
        </div>

        <!-- Mostrar mensaje de error para subcategorías si existe -->
        <div *ngIf="subcategoryError" class="text-danger text-[12px] px-4 mb-2">
          {{ subcategoryError }}
        </div>

  <ng-container *ngFor="let filter of filters; let i = index">
          <!-- Filtro de categoría con indicador de carga -->
          <div *ngIf="filter.id === 'category'" class="relative">
            <app-filter-input
              [input]="filter"
              [value]="getFilterValue(filter.id)"
              (map)="toggleFilters()"
              (filterChange)="updateFilter($event)"
            ></app-filter-input>

            <!-- Indicador de carga para categorías -->
            <div *ngIf="isLoadingCategories" class="absolute right-8 top-12 transform -translate-y-1/2">
              <ion-spinner name="crescent" color="primary" class="w-5 h-5"></ion-spinner>
            </div>
          </div>

          <!-- Filtro de subcategoría con indicador de carga -->
          <div *ngIf="filter.id === 'subcategory'" class="relative">
            <app-filter-input
              [input]="filter"
              [value]="getFilterValue(filter.id)"
              (map)="toggleFilters()"
              (filterChange)="updateFilter($event)"
            ></app-filter-input>

            <!-- Indicador de carga para subcategorías -->
            <div *ngIf="isLoadingSubcategories" class="absolute right-8 top-12 transform -translate-y-1/2">
              <ion-spinner name="crescent" color="primary" class="w-5 h-5"></ion-spinner>
            </div>
          </div>

          <!-- Start/End dates side-by-side when adjacent (only on non-web views) -->
          <div *ngIf="filter.id === 'startDate' && filters[i+1]?.id === 'endDate' && !isWeb" class="flex gap-2 items-stretch w-full">
            <div class="flex-1">
              <app-filter-input
                [input]="filter"
                [value]="getFilterValue(filter.id)"
                (map)="toggleFilters()"
                (filterChange)="updateFilter($event)"
              ></app-filter-input>
            </div>
            <div class="flex-1">
              <app-filter-input
                [input]="filters[i+1]"
                [value]="getFilterValue(filters[i+1].id)"
                (map)="toggleFilters()"
                (filterChange)="updateFilter($event)"
              ></app-filter-input>
            </div>
          </div>

          <!-- Otros filtros (avoid skipping on web where grouping is disabled) -->
          <app-filter-input
            *ngIf="filter.id !== 'category' && filter.id !== 'subcategory' && !(filter.id === 'endDate' && filters[i-1]?.id === 'startDate' && !isWeb) && !(filter.id === 'startDate' && filters[i+1]?.id === 'endDate' && !isWeb)"
            [input]="filter"
            [value]="getFilterValue(filter.id)"
            (map)="toggleFilters()"
            (filterChange)="updateFilter($event)">
          </app-filter-input>
        </ng-container>
      </div>

      <ion-button
        mode="ios"
        color="light"
        class="w-full mt-4 mb-2 app-shadow sticky-button"
        (click)="applyFilters()"
        size="small"
      >
        {{ 'FILTERS.APPLY_FILTER' | translate }}
        <span *ngIf="activeFiltersCount > 0" class="ml-2 bg-primary text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
          {{ activeFiltersCount }}
        </span>
      </ion-button>
    </div>
  </ion-content>
</ion-menu>
